/* Clarion Camping — scroll reveal + hero parallax + journey rail spy.
   The hidden state lives in cc-motion.css under html.cc-js; this file only
   adds .cc-in as elements enter the viewport. */
(function () {
  window.__ccRevealReady = true;

  var SEL = [
    '.cc-hero__inner > *',
    '.cc-head',
    '.cc-paths > *',
    '.cc-kits > *',
    '.cc-notes > *',
    '.cc-cols > *',
    '.cc-choose__card',
    '.cc-promise__cell',
    '.cc-trust__item',
    '.cc-split > div',
    '.cc-faq details',
    '.cc-res__card',
    '.cc-ev',
    '.cc-gal figure',
    '.cc-check',
    '.cc-reassure',
    '.cc-step__media',
    '.cc-step__text',
    '.cc-email__inner > *',
    '.cc-btns',
    '.cc-founder__media',
    '.cc-founder__text',
    '.cc-fail__item',
    '.cc-pit__inner > *'
  ].join(',');

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function showAll(root) {
    var all = (root || document).querySelectorAll(SEL);
    for (var i = 0; i < all.length; i++) all[i].classList.add('cc-in');
  }

  if (reduce || !('IntersectionObserver' in window)) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { showAll(); });
    } else {
      showAll();
    }
    return;
  }

  var io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('cc-in');
        io.unobserve(entry.target);
      });
    },
    { rootMargin: '0px 0px -14% 0px', threshold: 0.05 }
  );

  function stagger(el) {
    var parent = el.parentElement;
    if (!parent) return 0;
    var sibs = parent.children;
    var n = 0;
    for (var i = 0; i < sibs.length; i++) {
      if (sibs[i] === el) break;
      if (sibs[i].nodeType === 1) n++;
    }
    return Math.min(n, 6) * 95;
  }

  function observe(root) {
    var nodes = (root || document).querySelectorAll(SEL);
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (el.classList.contains('cc-in') || el.dataset.ccObs === '1') continue;
      el.dataset.ccObs = '1';
      var d = stagger(el);
      if (d) el.style.transitionDelay = d + 'ms';
      io.observe(el);
    }
  }

  function parallax() {
    var heroImg = document.querySelector('[data-cc-parallax]');
    if (!heroImg) return;
    var scroller = document.querySelector('.page-wrapper');
    var ticking = false;

    function frame() {
      ticking = false;
      var y = scroller ? scroller.scrollTop : window.pageYOffset;
      if (y > window.innerHeight * 1.3) return;
      heroImg.style.transform = 'translate3d(0,' + (y * 0.16).toFixed(1) + 'px,0) scale(1.06)';
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(frame);
    }

    if (scroller) scroller.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('scroll', onScroll, { passive: true });
    frame();
  }

  function journeyRail() {
    var rail = document.querySelector('[data-cc-rail]');
    if (!rail) return;
    var links = rail.querySelectorAll('a[href^="#"]');
    if (!links.length) return;
    var map = {};
    for (var i = 0; i < links.length; i++) {
      var id = links[i].getAttribute('href').slice(1);
      var target = document.getElementById(id);
      if (target) map[id] = links[i];
    }
    var spy = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (en) {
          var a = map[en.target.id];
          if (!a) return;
          if (en.isIntersecting) {
            for (var k in map) map[k].removeAttribute('aria-current');
            a.setAttribute('aria-current', 'step');
          }
        });
      },
      { rootMargin: '-45% 0px -45% 0px' }
    );
    for (var key in map) spy.observe(document.getElementById(key));
  }

  function boot() {
    observe(document);
    parallax();
    journeyRail();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  document.addEventListener('shopify:section:load', function (e) {
    observe(e.target);
  });
})();